import { render, staticRenderFns } from "./SocialDebtorsUploadError.vue?vue&type=template&id=32cb30ec&scoped=true&"
import script from "./SocialDebtorsUploadError.vue?vue&type=script&lang=js&"
export * from "./SocialDebtorsUploadError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb30ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
